import { FilterResult } from '../../../repository.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { Observable } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { FormControl as WncmFormControl } from '../form-control.model';

export const _filter = (opt: any[], value: string): string[] => {
	const filterValue = value.toLowerCase();

	return opt.filter((item) => item.name.toLowerCase().indexOf(filterValue) === 0);
};

@Component({
	selector: 'wncm-form-control-autocomplete-with-group-product',
	templateUrl: './form-control-autocomplete-with-group-product.html',
	styleUrls: ['../form-control.component.scss', './form-control-autocomplete-with-group-product.scss']
})
export class FormControlAutocompleteWithGroupProductComponent extends FormControlComponent implements OnInit {
	inputControl: WncmFormControl;

	optionForm: UntypedFormGroup = this.fb.group({
		optionGroup: ''
	});

	@Input()
	from: Observable<FilterResult<any>>;

	@Input()
	label: string;

	@Input() parentFormGroup: UntypedFormGroup;

	// @Input()
	// multiple: boolean;

	@Input()
	readOnly: boolean;

	options = [];

	displayedOptions: Observable<any[]>;

	private items: FilterResult<any>;

	constructor(private translate: TranslateService, private fb: UntypedFormBuilder) {
		super();

		if (this.readOnly) {
			this.control.disable();
		}
	}

	initInputTxt() {
		this.options.forEach((opt) => {
			opt.activities.forEach((act) => {
				if (act.id == this.control.value) {
					this.inputControl.setValue(act.name);
				}
			});
		});
	}

	ngOnInit() {
		this.inputControl = new WncmFormControl('inputControl');

		if (this.parentFormGroup != null) {
			this.parentFormGroup.addControl('inputControl', this.inputControl);
		}

		this.control.validators$.value.forEach((next) => {
			this.inputControl.addValidator(next);
		});

		this.control.validationMessages$.value.forEach((next) => {
			this.inputControl.addValidationMessage(next);
		});

		this.control.statusChanges.subscribe((c) => {
			this.inputControl.markAsTouched();

			if (c == 'INVALID' && !this.control.value) {
				this.inputControl.setValue(null);
			}
		});

		this.control.valueChanges.subscribe((v) => {
			this.initInputTxt();
		});
		super.ngOnInit();

		this.displayedOptions = this.inputControl!.valueChanges.pipe(
			startWith(''),
			map((value) => this._filterGroup(value))
		);
	}

	private refreshOptions() {

		this.options = this.items.items;
		this.initInputTxt();
		// this.options = this.items.items ? this.items.items.map<SelectOption>(i =>
		//   <SelectOption>{
		//     id: i.id,
		//     label: this.label === 'translationKey' ? this.translate.instant(i[this.label]) : i[this.label]
		//   }) : [];
	}

	private _filterGroup(value: string): any[] {
		if (value) {

			return this.options
				.map((group) => ({
					name: group.name,
					activities: _filter(group.activities, value)
				}))
				.filter((group) => group.activities.length > 0);
		}

		return this.options;
	}

	onEnter(evt: any) {
		this.control.setValue(evt.id);

		// if (evt.source.selected) {

		//  }
	}
}

export class SelectOption {
	id: any;
	label: string;
}
